<template>
  <div>
    <template v-if="isLoggedIn">
      <h2 class="mt-12 border-0 text-xl">Gespeicherte Lieferadressen ({{ userLocations.length }}):</h2>

      <div v-if="userLocations.length === 0" class="bg-orange-lightest border-l-4 border-orange text-orange-darkest p-4 mb-4" role="alert">
        <p class="font-bold">Noch keine Adressen vorhanden</p>
        <p>Deine Adressen werden automatisch beim Bestellen gespeichert und können anschließend hier bearbeitet werden</p>
      </div>

      <div v-for="location in userLocations" :key="location.id" class="bg-white mx-auto shadow-lg rounded-lg mb-6 overflow-hidden p-4">
        <h4 v-if="location.item_firma">📍 {{ location.item_firma }}</h4>
        <h4 v-if="!location.item_firma">📍 {{ location.item_vorname }} {{ location.item_name }}</h4>
        <template v-if="location.item_firma">{{ location.item_vorname }} {{ location.item_name }}<br /></template>
        {{ location.item_strasse }} {{ location.item_hausnummer }}<br />
        {{ location.item_plz }} {{ location.item_ort_einfach }} ({{ location.item_ortsteil }})<br />
        {{ location.item_address_addon }}<br />
        <br />
        <a href="javascript:void(0)" @click="editAddress(location)" class="inline-block text-black no-underline">✏️ Adresse bearbeiten</a><br />
        <a href="javascript:void(0)" @click="removeAddress(location)" class="inline-block mt-2 text-black no-underline">🗑 Adresse löschen</a>
      </div>

      <input type="button" @click="addAddress()" class="mt-2 bg-green-heinz text-black py-3 px-2 mb-8 rounded cursor-pointer" value="weitere Adresse hinzufügen" /><br />
    </template>

    <dialog class="address-dialog z-50" name="addressform" id="address-dialog">
      <div class="dialog__content">
        <h3 v-if="!addressForm.id" class="headline-extras">Adresse hinzufügen</h3>
        <h3 v-if="addressForm.id" class="headline-extras">Adresse bearbeiten</h3>

        <form v-on:submit.prevent="saveAddress()">
          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_firma">
            Firma (optional)
            <input v-model="addressForm.item_firma" class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_firma" type="text" placeholder="Firma" />
          </label>

          <div class="flex flex-wrap lg:flex-no-wrap w-full">
            <label class="block w-full lg:w-1/2 lg:pr-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_vorname">
              Vorname
              <input v-model="addressForm.item_vorname" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_vorname" type="text" placeholder="Vorname" />
            </label>
            <label class="block w-full lg:w-1/2 lg:pl-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_name">
              Nachname
              <input v-model="addressForm.item_name" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_name" type="text" placeholder="Nachname" />
            </label>
          </div>

          <div class="flex flex-wrap lg:flex-no-wrap w-full">
            <label class="block w-full lg:w-2/3 lg:pr-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_strasse">
              Straße
              <input v-model="addressForm.item_strasse" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_strasse" type="text" placeholder="Straße" />
            </label>
            <label class="block w-full lg:w-1/3 lg:pl-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_hausnummer">
              Hausnummer
              <input v-model="addressForm.item_hausnummer" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_hausnummer" type="text" placeholder="Hausnummer" />
            </label>
          </div>

          <div class="flex flex-wrap lg:flex-no-wrap w-full">
            <label class="block w-full lg:w-1/3 lg:pr-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_plz">
              PLZ
              <input v-model="addressForm.item_plz" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_plz" type="text" placeholder="PLZ" />
            </label>
            <span v-if="!geoOptions.length" class="block w-full lg:w-2/3 lg:pl-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_geoid">
              Bitte zuerst die PLZ eingeben
            </span>
            <label v-else class="block w-full lg:w-2/3 lg:pl-1 mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_geoid">
              Ort
              <select v-if="geoOptions.length" v-model="addressForm.item_geoid" required class="block appearance-none w-full h-auto border border-green-heinz text-grey-darker py-3 px-4 pr-8 rounded" id="grid-item_geoid">
                <option v-for="geoOption in geoOptions" :key="geoOption.id" :value="geoOption.id">{{ geoOption.item_ort_einfach }} ({{ geoOption.item_ortsteil }})</option>
              </select>
              <div v-if="!geoOptions.length">
                Bitte zuerst die PLZ eingeben
              </div>
            </label>
          </div>

          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-item_address_addon">
            Adresszusatz / Hinweise (optional)
            <input v-model="addressForm.item_address_addon" class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-item_address_addon" type="text" placeholder="Adresszusatz" />
          </label>

          <div class="flex flex-wrap lg:flex-no-wrap w-full mt-4">
            <input type="button" v-on:click="closeDialog('address-dialog')" class="block w-full mt-4 shadow bg-grey hover:bg-grey-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="abbrechen" />
            <div class="w-1/8"></div>
            <input type="submit" class="block w-full mt-4 shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="Adresse speichern" />
          </div>
        </form>
      </div>
    </dialog>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import endpoints from '../endpoints'
import axios from 'axios'
import { closeDialog, openDialog } from '../utils/dialog'

export default {
  name: 'UserAddresses',

  data () {
    return {
      addressFormDefault: {
        id: null,
        item_firma: '',
        item_vorname: '',
        item_name: '',
        item_strasse: '',
        item_hausnummer: '',
        item_plz: '',
        item_geoid: '',
        item_address_addon: ''
      },
      addressForm: {},
      geoOptions: [],
      showAddAdressDialog: false
    }
  },

  computed: {
    ...mapGetters([
      'userLocations',
      'isLoggedIn'
    ])
  },

  watch: {
    'addressForm.item_plz' (to) {
      this.search(to)
    }
  },

  created () {
    this.resetAddressForm()
  },

  methods: {
    ...mapActions([
      'deleteLocation',
      'addOrUpdateLocation'
    ]),

    closeDialog,

    removeAddress (location) {
      if (window.confirm('Bist du dir sicher, dass du die gewählte Adresse löschen möchtest?')) {
        this.deleteLocation(location.id)
      }
    },

    resetAddressForm () {
      this.addressForm = this.addressFormDefault
    },

    addAddress () {
      this.resetAddressForm()
      openDialog('address-dialog')
    },

    editAddress (address) {
      this.addressForm = {...address}
      openDialog('address-dialog')
    },

    saveAddress (event) {
      if (event) event.preventDefault()
      this.addOrUpdateLocation(this.addressForm)
      closeDialog('address-dialog')
    },

    search (q) {
      if (q.length < 5) {
        this.geoOptions = []
        return
      }

      axios.post(endpoints.locations, { 'query': q })
        .then(response => {
          this.geoOptions = response.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserAddresses.vue